import { render, staticRenderFns } from "./DomainProgressReviewTable.vue?vue&type=template&id=6734217d&scoped=true"
var script = {}
import style0 from "./DomainProgressReviewTable.vue?vue&type=style&index=0&id=6734217d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6734217d",
  null
  
)

export default component.exports